import React from 'react';
import { Row, Col, Carousel, Button } from 'antd';
import { ModalTheme } from '../../../components/modal/index.jsx';
import { ContainerButton } from '../../../styles/global-style.js';
import { ButtonTheme } from '../../../components/buttons/index.jsx';
import { TextCustom, TextHeadTitle } from '../../../components/text/index.jsx';
import { useMediaQuery } from 'react-responsive';
import { color, GUTTER_LAYOUT, LINE_ADD_FRIEND_URL } from '../../../resources';
import { CopyOutlined, CheckOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { navigateTo } from '../../../utils/navigation';
import { ROUTES_PATH } from '../../../resources/routes-name';
import lineIcon from '../../../assets/icons/line.png';
import appleIcon from '../../../assets/images/logo-text.png';


const ArrowPrev = ({ currentSlide, slideCount, ...props }) => (
  <LeftOutlined
    {...props}
    style={{
      ...props.style,
      color: '#605b5bff',
      fontSize: '24px',
      left: '10px',
      zIndex: 10,
      cursor: 'pointer',
      transition: '0.2s',
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = '#000')}
    onMouseLeave={(e) => (e.currentTarget.style.color = '#605b5bff')}
  />
);

const ArrowNext = ({ currentSlide, slideCount, ...props }) => (
  <RightOutlined
    {...props}
    style={{
      ...props.style,
      color: '#605b5bff',
      fontSize: '24px',
      right: '10px',
      zIndex: 10,
      cursor: 'pointer',
      transition: '0.2s',
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = '#000')}
    onMouseLeave={(e) => (e.currentTarget.style.color = '#605b5bff')}
  />
);


export const HelpModal = ({ open, onToggle, title, data }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return (
    <ModalTheme title={title} open={open} onToggle={onToggle} width={920}>
      <div
        style={{ paddingBottom: '20px', marginBottom: '16px', borderBottom: '2px solid #e8e8e8' }}
      >
        {/* {!isMobile && (
          <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
            {data.map((el, i) => {
              return (
                <Col
                  xs={12}
                  sm={el.col}
                  md={el.col}
                  lg={el.col}
                  xl={el.col}
                  style={{ textAlign: 'center' }}
                >
                  <img src={el.image} width={'200'} key={`help_${i}`} />
                  {el.text && (
                    <TextCustom text={el.text} size="20px" styled={{ paddingTop: '14px' }} />
                  )}
                  {el.subtext && (
                    <TextCustom
                      text={el.subtext}
                      size="20px"
                      styled={{ paddingTop: '14px', color: 'red' }}
                    />
                  )}
                </Col>
              );
            })}
          </Row>
        )} */}


        <Carousel
          arrows
          prevArrow={<ArrowPrev />}
          nextArrow={<ArrowNext />}
        >
          {data.map((el, i) => {
            return (
              <div key={`help_${i}`} style={{ textAlign: 'center' }}>
                <img src={el.image} width={'200'} style={{ margin: 'auto' }} />
                <TextCustom
                  text={el.text}
                  size="20px"
                  styled={{ paddingTop: '14px', textAlign: 'center' }}
                />
              </div>
            );
          })}
        </Carousel>

      </div>
      <ContainerButton center>
        <ButtonTheme
          useFor="BACK"
          onClick={onToggle}
          title="ปิด"
          disableIcon
          style={{ width: '150px' }}
        />
      </ContainerButton>
    </ModalTheme>
  );
};

export const ConfirmModal = ({ open, onToggle, handleCopy, data }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const styledBtn = {
    color: color.darkgrey,
    backgroundColor: color.yellow,
    borderColor: color.yellow,
    width: !isMobile ? '20%' : '47%',
  };
  const { copied, bookingId } = data;
  return (
    <ModalTheme
      title={null}
      open={open}
      onToggle={onToggle}
      width={920}
      maskClosable={null}
      closable={null}
      keyboard={null}
    >
      <div style={{ paddingBottom: '20px', marginBottom: '16px' }}>
        <div style={{ textAlign: 'center' }}>
          <TextHeadTitle
            text={'ยืนยันการนัดหมาย'}
            bold
            align={'center'}
            styled={{ marginBottom: '12px' }}
          />
          <TextCustom
            text={
              'กรุณา แอดไลน์เพื่อยืนยันนัดหมาย และรับโปรพิเศษทันที 1,000 บาท 📷อย่าลืม Capture หน้าจอนี้แล้วส่งให้แอดมินผ่าน'
            }
            size={'24px'}
            color={color.black_grey}
          />
          <TextCustom
            text={'LineOA:👉 @applehouseth (มี@ด้านหน้า)'}
            size={'24px'}
            color={color.black_grey}
          />
          <div>
            <span className="text-detail">หมายเลขการนัดหมายของคุณคือ: </span>
            <Button onClick={handleCopy} disabled={copied} className="btn-copy">
              {bookingId}
              {copied ? <CheckOutlined /> : <CopyOutlined />}
            </Button>
            <TextCustom
              text={'เจ้าหน้าที่จะให้บริการเฉพาะลูกค้าที่แอดไลน์และส่งภาพนี้เท่านั้น'}
              size={'24px'}
              color={color.red}
            />
          </div>
        </div>
      </div>
      <ContainerButton center>
        <ButtonTheme
          useFor="CONFIRM"
          onClick={() => {
            navigateTo({
              pathname: ROUTES_PATH.ROUTE_THANKYOU.PATH,
            });
          }}
          title="ยืนยันนัดหมาย"
          disableIcon
          style={styledBtn}
        />
      </ContainerButton>
      <div style={{ textAlign: 'start', marginTop: '10px' }}>
        <TextCustom text={'*แอดไลน์เพื่อรับโปร 1,000 บาท'} size={'24px'} color={color.red} />
      </div>
    </ModalTheme>
  );
};

export const ConditionDeliveryModal = ({ open, onToggle }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const styledBtn = {
    color: color.darkgrey,
    backgroundColor: color.yellow,
    borderColor: color.yellow,
    width: !isMobile ? '20%' : '47%',
  };

  return (
    <ModalTheme
      title={null}
      open={open}
      onToggle={onToggle}
      width={720}
      maskClosable={null}
      closable={null}
      keyboard={null}
    >
      <div style={{ textAlign: 'center' }}>
        <TextCustom
          text={'นัดรับนอกสถานที่ เฉพาะกรุงเทพฯ และปริมลฑลเท่านั้น'}
          size={'24px'}
          color={color.black_grey}
        />
        <TextCustom
          text={'ต่างจังหวัด หากต้องการขายไอโฟน ไอแพด'}
          size={'24px'}
          color={color.black_grey}
        />
        <TextCustom
          text={'รบกวนติดต่อแอดมิน LineOA: @applehouseth (มี@ด้านหน้า)'}
          size={'24px'}
          color={color.black_grey}
        />
      </div>
      <ContainerButton center>
        <ButtonTheme
          useFor="CONFIRM"
          onClick={onToggle}
          title="รับทราบ"
          disableIcon
          style={styledBtn}
        />
      </ContainerButton>
    </ModalTheme>
  );
};

export const ContractModal = ({ open, onToggle }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const styledBtn = {
    color: color.darkgrey,
    backgroundColor: color.yellow,
    borderColor: color.yellow,
    width: !isMobile ? '20%' : '47%',
  };

  const handleClick = async () => {
    window.open(LINE_ADD_FRIEND_URL);
    onToggle();

    const ga = await setGoogleAnalytics();
    if (ga) {
      ga.event("AppleSure_Add_Line", {
        category: "Sell Iphone Flow",
        label: "Add Line",
      });
    }
  };

  return (
    <ModalTheme
      title={null}
      open={open}
      onToggle={onToggle}
      width={620}
      maskClosable={true}
      closable={true}
      keyboard={null}
    >
      <div style={{ textAlign: 'center' }}>
        <TextCustom
          text={'หากต้องการขายด่วน รบกวนติดต่อแอดมิน'}
          size={'24px'}
          color={color.black_grey}
        />
        <TextCustom
          text={'LineOA: @applehouseth (มี@ด้านหน้า)'}
          size={'24px'}
          color={color.black_grey}
        />
      </div>
      <div style={{ textAlign: 'center', margin: '40px 0' }}>
        <div style={{ marginTop: 24 }}>
          <Button
            icon={
              <img
                src={lineIcon}
                alt="LINE"
                style={{ width: 25, height: 25, marginRight: '5px', fill: '#06C755' }}
              />
            }
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '25px',
              fontSize: '20px',
            }}
            onClick={() => {
              window.open(LINE_ADD_FRIEND_URL);
              onToggle();
            }}
          >
            แอดเพื่อน (Add LINE)
          </Button>
        </div>
      </div>
    </ModalTheme>
  );
};

export const NotBuyingModal = ({ open, onToggle }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const styledBtn = {
    color: color.darkgrey,
    backgroundColor: color.yellow,
    borderColor: color.yellow,
    width: !isMobile ? '20%' : '47%',
  };

  return (
    <ModalTheme
      title={null}
      open={open}
      onToggle={onToggle}
      width={620}
      // prevent closing by clicking mask or pressing ESC
      maskClosable={false}
      closable={false}
      keyboard={false}
    >
      <div style={{ textAlign: 'center' }}>
        {/* icon above the message */}
        <div style={{ width: '100px', margin: '0 auto', textAlign: 'center' }}>
          <img
            src={appleIcon}
            alt="apple icon"
            style={{ width: '100%', height: 'auto', display: 'block', margin: '0 auto 12px' }}
          />
        </div>
        <TextCustom
          text={'ขออภัยค่ะ ทางร้านไม่สามารถรับซื้อได้ เนื่องจากสภาพเครื่อง'}
          size={'20px'}
          color={color.black_grey}
        />
        <TextCustom
          text={'ไม่อยู่ในเกณฑ์ที่บริษัทฯ กำหนด'}
          size={'20px'}
          color={color.black_grey}
        />
        <TextCustom
          text={'หากต้องการสอบถามเพิ่มเติม ติดต่อแอดมิน '}
          size={'20px'}
          color={color.black_grey}
          styled={{ marginTop: '20px' }}
        />
        <TextCustom
          text={'LineOA: @applehouseth (มี@ด้านหน้า)'}
          size={'20px'}
          color={color.black_grey}
        />
      </div>
      <div style={{ textAlign: 'center', margin: '40px 0' }}>
        <div style={{ marginTop: 24 }}>
          <Button
            icon={
              <img
                src={lineIcon}
                alt="LINE"
                style={{ width: 25, height: 25, marginRight: '5px', fill: '#06C755' }}
              />
            }
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '25px',
              fontSize: '20px',
            }}
            // open link but do NOT close the modal; user must use the X button to close
            onClick={() => {
              window.open(LINE_ADD_FRIEND_URL);
            }}
          >
            แอดเพื่อน (Add LINE)
          </Button>
        </div>

        <ContainerButton center style={{ marginTop: '20px' }}>
          <ButtonTheme
            useFor="CONFIRM"
            onClick={() => {
              window.location.href = 'https://applehouseth.com/';
            }}
            title="กลับไปหน้าประเมิน"
            disableIcon
            style={styledBtn}
          />
        </ContainerButton>
      </div>
    </ModalTheme>
  );
};
